export default {
	termsAndConditions: {
		lastUpdate: 'Posledná aktualizácia: 10. júna 2024',
		content: `
		<p>Podmienky, ktoré nájdete nižšie, sú dôležité, pretože:</p>
		<ul>
			<li>Ustanovujú svoje zákonné práva na stránke {siteName}.</li>
			<li>Vysvetlite nám práva, ktoré nám udeľujete, keď používate {siteName}.</li>
			<li>
				Popisujú pravidlá, ktoré musí každý rešpektovať pri používaní {siteName}.
			</li>
		</ul>
		<p>
			Pozorne si prečítajte tieto Podmienky, ako aj naše {privacyPolicyLink} a všetky ďalšie
			dokumenty uvedené v týchto podmienkach.
		</p>
		<p>Začnime...</p>
		<h3>1. ÚVOD A ÚDAJE O {siteNameUpper}.</h3>
		<p>
			Webovú stránku {websiteLink} (ďalej len „webová stránka“) vlastní spoločnosť
			{siteName} S.L (ďalej len „{siteName}“), spoločnosť
			zaregistrovaná v súlade so španielskymi právnymi predpismi so sídlom na Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Barcelona), držiteľ čísla CIF
			B-56.768.260 a registrovaná v Obchodnom registri Barcelony vo zväzku
			49065, Folio 0033, Sheet B-606324, 1. Registration.
		</p>
		<p>
			{siteName} vám dáva k dispozícii webovú stránku, aby ste sa na ňu mohli dostať
			spoznajte nás lepšie, spoznajte služby, ktoré poskytujeme a ak chcete, môžete nás kontaktovať
			a ak je to vhodné, uzavrieť s nami zmluvu.
		</p>
		<h3>2. ÚČEL A ROZSAH UPLATNENIA PODMIENOK POUŽÍVANIA</h3>
		<p>
			Tieto podmienky používania tvoria spolu s {privacyPolicyLink} a
			{cookiesPolicyLink}, právny rámec, ktorý upravuje používanie webovej stránky
			{websiteLink}. Tieto podmienky používania vám budú k dispozícii na webovej stránke
			v angličtine, aby ste si ich mohli kedykoľvek prezrieť, archivovať alebo vytlačiť
			kedykoľvek chceš.
		</p>
		<p>
			Ak chcete vedieť akékoľvek otázky týkajúce sa liečby, ktorú vykonáva {siteName}.
			vašich osobných údajov, navštívte naše {privacyPolicyLink} a naše {cookiesPolicyLink}.
			Obe zásady vám budú k dispozícii aj v angličtine, aby ste mohli
			si ich môžete kedykoľvek prezrieť, archivovať alebo vytlačiť.<br />
			{siteName} používa na webových stránkach súbory cookie tretích strán. Ak chcete zistiť viac
			o type súborov cookie používaných na webe {websiteLink}, ich účele a spôsobe
			na konfiguráciu Vášho prehliadača v prípade, že si neželáte, aby sme tieto cookies používali,
			navštívte naše {cookiesPolicyLink}.
		</p>
		<p>
			Obe tieto podmienky používania, ako aj {privacyPolicyLink} a 
			{cookiesPolicyLink} boli pripravené v súlade s ustanoveniami aktuálneho
			platnými predpismi, okrem iného zákon č. 34/2002 Zz o službách
			Informačná spoločnosť a elektronický obchod a nariadenie (EÚ) 2016/679 z
			Európskeho parlamentu a Rady z 27. apríla 2016 o
			ochrany fyzických osôb pri spracúvaní osobných údajov
			údajov a voľný obeh týchto údajov a ktorou sa riadi smernica 95/46/ES
			sa zrušuje.
		</p>
		<h3>3. PRÍSTUP NA STRÁNKU A AKCEPTÁCIA</h3>
		<p>
			Prístup na webovú stránku je bezplatný s výnimkou časti súvisiacej s nákladmi
			pripojenie cez telekomunikačnú sieť poskytovanú internetom
			poskytovateľa prístupu, s ktorým máte zmluvu. Webovú stránku môžete voľne prehliadať
			a pristupujte k nemu toľkokrát, koľkokrát chcete. Ak chcete získať prístup a navigáciu na webovej stránke,
			nemusíte sa registrovať, okrem prípadov, keď si chcete prenajať službu.
		</p>
		<p>
			Používanie webovej stránky vám dáva stav používateľa webovej stránky
			(ďalej len „používateľ“) a znamená váš úplný a bezvýhradný súhlas s
			tieto podmienky používania, ako aj {privacyPolicyLink} a {cookiesPolicyLink}
			webovej stránky. Ďalej súhlasíte s tým, že službu nebudete používať na nezákonné účely
			účely.
		</p>
		<p>
			Vstupom na webovú stránku a jej prehliadaním vyhlasujete pod svojím
			zodpovednosť za to, že ste plnoletý a že máte potrebný zákon
			schopnosť pristupovať na webovú stránku a používať ju, pričom zároveň vyhlasujete, že ste v plnom rozsahu
			rozumieť týmto podmienkam používania a bez výhrad ich akceptovať.
		</p>
		<p>
			Na druhej strane vás informujeme, že z právnych dôvodov archivujeme
			elektronické dokumenty, v ktorých sú nákupy formalizované. Môžete pristupovať
			tieto dokumenty môžete kedykoľvek vyžiadať na adrese: {supportLink}.
		</p>
		<h3>4. PODMIENKY POUŽÍVANIA WEBOVEJ STRÁNKY</h3>
		<p>
			Používateľ súhlasí s používaním webovej stránky v súlade s týmito podmienkami používania,
			platnú legislatívu a dobrú vieru. Používateľ teda odpovie na {siteName}.
			 a pred akoukoľvek treťou stranou za vzniknuté škody a straty
			použitie v rozpore s týmito podmienkami, právnymi predpismi a v dobrej viere
			zo strany Používateľa Webovej stránky.
		</p>
		<h3>5. POPIS SLUŽBY</h3>
		<p>
			Prostredníctvom Služby umožňuje {siteName} predplatiť si službu
			vykonávať úpravu obrázkov.
		</p>
		<p>
			Jazyk, v ktorom je zmluva medzi {siteName} a kupujúcim
			bude uzavretá krajina pôvodu.<br />
			Proces nákupu v online službe bude nasledujúci:
		</p>
		<ol>
			<li>Na webovej lokalite sa musíte zaregistrovať pomocou používateľského mena a hesla.</li>
			<li>
				V čase registrácie si používateľ musí vybrať jeden z platobných plánov
				nájdete v sekcii Ceny a budú vám pridelené kredity v závislosti od
				vybraný plán. Každý kredit vám umožní upraviť jeden obrázok.
			</li>
			<li>
				Po zakúpení služby bude užívateľovi k dispozícii administrácia
				panel, kde nájdu:
				<ul>
					<li>
						Sekcia so zoznamom všetkých obrázkov, ktoré boli spracované
						môžete ho upravovať toľkokrát, koľkokrát chcete, a stiahnuť si ho do svojho
						zariadenie.
					</li>
					<li>
						Časť Plány a platby na nahliadnutie do faktúr a zrušenie
						predplatné.
					</li>
					<li>Sekcia Môj účet, v ktorej je možné zmeniť predvoľby účtu.</li>
				</ul>
			</li>
		</ol>
		<p>
			Po uskutočnení nákupu služby bude potvrdený o
			odoslanie e-mailu, maximálne do 24 hodín, na adresu, ktorú máte
			uvedené. Uvedie službu, spôsob zrušenia predplatného, jeho
			sumu, príslušné dane, spôsob platby a príslušné podmienky a
			podmienky.
		</p>
		<h4>5.1 Predplatné</h4>
		<p>
			Predplatné služby sa líši v závislosti od zvoleného plánu a bude
			automaticky obnovuje na rovnakú dobu až do jej ukončenia.
			Ak nezrušíte svoje predplatné, oprávňujete nás na načítanie
			zodpovedajúci ročný poplatok za predplatné vo vašom spôsobe platby.
		</p>
		<p>
			Svoje predplatné Služby môžete kedykoľvek zrušiť a urobíte to
			mať k nemu prístup až do konca ročného fakturačného obdobia. Komu
			v rozsahu povolenom zákonom, platby sú nevratné a neposkytujeme
			náhrady alebo kredity za čiastočné ročné predplatné obdobia.
		</p>
		<h3>6. CENA A DANE</h3>
		<p>
			Ceny produktov ponúkaných na {siteName} sú uvedené v eurách
			(€) alebo mena krajiny, z ktorej sa nákup uskutočňuje, Hodnota
			K cene tovaru sa účtuje daň z pridanej hodnoty (DPH) platná v čase nákupu
			Produkty.
		</p>
		<p>
			V každom prípade môže byť operácia oslobodená alebo nepodlieha DPH v závislosti od
			krajinu vášho pobytu alebo podmienky, v ktorých konáte. Pre tento dôvod,
			v niektorých prípadoch môže byť konečná cena objednávky zmenená vzhľadom na
			jeden zobrazený.<br />
			Nákupy uskutočnené subjektmi oslobodenými od platenia DPH to označia
			odosielanie ich IČ DPH/NIF e-mailom na adresu {supportLink}, bez zaznamenávania
			nákupy s uvedenou daňou.
		</p>
		<h3>7. SPÔSOB PLATBY</h3>
		<p>
			Online platbu za zakúpenú službu je možné uskutočniť kreditnou alebo debetnou kartou.
			V tomto zmysle {siteName} informuje držiteľov kreditných a debetných kariet
			transakcie v internetovom obchode sa uskutočňujú prostredníctvom zabezpečenej platby
			brána, využívajúca technológiu SSL na zaručenie bezpečnosti prenosu dát.
		</p>
		<h3>8. PRÁVO NA VÝBER A VRÁTENIE PEŇAZÍ</h3>
		<h4>8.1. Právo na odstúpenie</h4>
		<p>
			Vzhľadom na typ produktu predávaného v našej online službe softvér v digitálnom formáte
			formáte QR, právo na odstúpenie od zmluvy sa neuplatní podľa
			článok 103 písm. m) kráľovského legislatívneho dekrétu 1/2007 zo 16. novembra
			že revidovaný text všeobecného zákona na ochranu spotrebiteľa a
			Používatelia a ďalšie doplňujúce zákony sú schválené.
		</p>
		<h4>8.2. Vrátenie peňazí</h4>
		<p>
			Bez ohľadu na plán zvolený používateľom, sumy zaplatené používateľom a do
			rozsah povolený zákonom nebude vrátený.
		</p>
		<p>
			Zmluvnú službu nemožno postúpiť ani previesť na iných používateľov
			služba.
		</p>
		<p>
			V každom prípade môže užívateľ využívať zmluvnú službu až do konca r
			zmluvné obdobie.
		</p>
		<h3>9. PLATNOSŤ PONÚK</h3>
		<p>
			Služby ponúkané v Službe a ich ceny budú dostupné za
			nákupu, kým sú v katalógu služieb zobrazených prostredníctvom tohto
			webovej stránky.
		</p>
		<p>
			V každom prípade si {siteName} vyhradzuje právo vykonať jeho úpravy
			v Službe považuje za vhodné, možnosť aktualizovať produkty a služby
			v závislosti od trhu.
		</p>
		<p>
			{siteName} si vyhradzuje právo zmeniť ceny bez predchádzajúceho upozornenia. my
			informujeme, že napriek aktualizáciám cien
			Servis, môžu obsahovať chyby. Akékoľvek chyby okamžite opravíme
			sa objavia, ale nebudú pre Službu záväzné.
		</p>
		<h3>10. BEZPEČNOSŤ</h3>
		<p>
			Ako je uvedené vyššie, celý postup nákupu, ako aj prenos
			vašich osobných údajov a platobných systémov, sa vykonáva na zabezpečenej stránke a
			šifrovaným spôsobom prostredníctvom protokolu SSL.
		</p>
		<p>
			Garantujeme bezpečnosť Služby v súlade s aktuálnymi
			technologické znalosti. {siteName} však nemôže zaručiť úplné znenie
			budúcej bezpečnosti Služby. V každom prípade sľubujeme nápravu a
			vykonať príslušné nápravné opatrenia na nápravu možného zabezpečenia
			porušenie čo najskôr.
		</p>
		<p>
			Súhlasíte s tým, že okamžite a e-mailom {supportLink} upozorníte {siteName}
			akejkoľvek situácii, ktorá by mohla viesť k odcudzeniu identity používateľa.
		</p>
		<h3>11. ÚPRAVY A NEPLATNOSŤ</h3>
		<p>
			Podmienky služby môžeme aktualizovať aj v budúcnosti
			ako vlastnosti a funkcie samotnej Služby.
		</p>
		<p>
			O zmenách podmienok vás budeme informovať prostredníctvom oznámenia
			na viditeľnom mieste na našej webovej stránke a/alebo e-mailom.
		</p>
		<p>
			Ak je deklarovaná akákoľvek klauzula zahrnutá v týchto podmienkach, úplne alebo
			čiastočne, neplatná alebo neúčinná, ovplyvní iba uvedené ustanovenie alebo časť
			je neplatná alebo neúčinná. Podmienky budú platiť v
			všetko ostatné, ktoré má takéto ustanovenie, alebo jeho časť, ktorej sa to týka
			neumiestňovanie.
		</p>
		<h3>12. NÁROKY A ČINNOSTI ODVEDENÉ ZO ZMLUVY</h3>
		<p>
			Pokiaľ je to možné, táto služba sa riadi španielskym právom.<br />
			S cieľom zjednodušiť riešenie nárokov prostredníctvom občianskeho súdneho konania a
			znížiť náklady, nevylučujeme možnosť podriadiť sa
			Equity Arbitráž Rozhodcovského súdu obchodných komôr a
			priemysel. V tomto zmysle a podľa platných predpisov
			 {siteName} informuje o existencii európskeho riešenia sporov online
			platforma, ktorá uľahčuje mimosúdne riešenie takýchto sporov pre
			zmluvy uzatvorené aj online medzi spotrebiteľmi a internetovou službou
			poskytovateľov. Táto platforma je prístupná prostredníctvom nasledujúcej webovej stránky:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. PRÁVA DUŠEVNÉHO A PRIEMYSELNÉHO VLASTNÍCTVA</h3>
		<p>
			Webová stránka a jej obsah podliehajú ochrane pri aplikácii
			aktuálne národné predpisy o duševnom a/alebo priemyselnom vlastníctve, as
			ako aj pri uplatňovaní medzinárodných dohovorov, ktoré sa v nich uplatňujú
			záležitosti. {siteName} je vlastníkom alebo má riadnu licenciu na všetky
			Práva duševného a priemyselného vlastníctva na webovej stránke a jej obsahu.
		</p>
		<p>
			Akákoľvek forma reprodukcie, distribúcie, verejnej komunikácie, transformácie,
			sprístupnenie a vo všeobecnosti akýkoľvek iný akt využívania, či už alebo nie
			na komerčné účely webovej stránky alebo jej obsahu, bez predchádzajúceho
			výslovný súhlas {siteName}. Je výslovne zakázané vymazávať
			identifikujúcich údaje {siteName} ako vlastníka intelektuálnych a
			Práva priemyselného vlastníctva webovej stránky alebo jej obsahu.
		</p>
		<p>
			{siteName} si vyhradzuje všetky práva duševného a priemyselného vlastníctva
			nad webovou stránkou a jej obsahom, pričom si vyhradzujú aj výkon akýchkoľvek právnych predpisov
			činnosti, ktoré tomu zodpovedajú, s cieľom zastaviť, zabrániť alebo stíhať akékoľvek
			nezákonné používanie webovej stránky alebo jej obsahu. V žiadnom prípade a pod č
			okolnostiam prístup na Webovú stránku alebo jej používanie Používateľom alebo treťou osobou
			strany predstavujú alebo naznačujú postúpenie akéhokoľvek druhu zo strany {siteName}
			práva duševného alebo priemyselného vlastníctva webovej stránky alebo jej obsahu.
			V žiadnom prípade neexistencia požiadavky zo strany {siteName} prestať používať
			Webové stránky alebo ich nezákonné alebo obsah v rozpore s týmito podmienkami môže byť
			chápané ako tichý súhlas zo strany {siteName} s takýmito použitiami alebo ako vzdanie sa práva
			o vykonaní akéhokoľvek právneho úkonu, ktorý mu môže zodpovedať.
		</p>
		<h3>14. ZODPOVEDNOSTI A ZÁRUKY</h3>
		<p>
			Používateľ musí používať webovú stránku a jej obsah v súlade s
			ustanovenia týchto podmienok používania, platnej legislatívy a dobrej viery. akýkoľvek
			používanie webovej stránky alebo jej obsahu v rozpore s týmito všeobecnými podmienkami,
			zákon alebo dobrá viera je výslovne zakázaná, bez ohľadu na to, či takéto použitie má
			ekonomický účel alebo nie.<br />
			Používateľ bude zodpovedný za akúkoľvek škodu alebo škodu spôsobenú {siteName}
			 alebo tretím stranám odvodeným priamo alebo nepriamo z akéhokoľvek použitia
			že Používateľ robí webovú stránku alebo jej obsah v rozpore s týmito
			podmienok, zákona, morálky, verejného poriadku alebo dobrej viery.
		</p>
		<p>
			Aby boli webové stránky a ich obsah prístupné používateľovi, {siteName}
			 vyžaduje služby poskytované tretími stranami. Je to možné
			napriek úsiliu, ktoré vynaložila stránka {siteName} o zachovanie dostupnosti webovej lokality
			a prístupný používateľom, môže byť jeho dostupnosť pozastavená, prerušená resp
			zrušené z dôvodov iných ako {siteName}. Preto {siteName}
			nezaručuje absenciu prerušení alebo chýb v prístupe k
			Webová stránka alebo jej obsah, ani to, že sú aktualizované alebo vždy zobrazené
			ich najnovšiu verziu. V dôsledku toho {siteName} akékoľvek odmieta
			zodpovednosť za škody, ktoré môžu vzniknúť Používateľovi alebo tretím stranám, ako je
			v dôsledku pozastavenia, prerušenia, nedostatočnej kontinuity, výpadku siete
			alebo odpojenie webovej stránky.
		</p>
		<p>
			V žiadnom prípade a za žiadnych okolností nebude {siteName} zodpovedať za
			škody alebo straty spôsobené používateľovi z príčin, ktoré nemožno pripísať {siteName}
			 ako napríklad a v žiadnom prípade neobmedzujúce prírodné
			katastrofy, situácie vyššej moci alebo krajnej núdze, vírusy, škodlivé
			komponenty, poruchy prehliadača, výpadky siete, narušenie počítača resp
			útoky tretích strán.
		</p>
		<h3>15. ODKAZY</h3>
		<p>
			Webové stránky, platformy, fóra, chaty, blogy alebo externé sociálne siete, ktoré
			odkaz alebo odkaz na webovú stránku musí jasne informovať, že nemajú
			autorizáciu alebo dohľad nad webom {siteName} a to, že prepojenie alebo
			odkaz neznamená, nepredpokladá ani nenaznačuje spojenie akéhokoľvek druhu medzi {siteName}
			 a webové stránky, platformy, fóra, chaty, blogy alebo externé stránky
			sociálne siete, ktoré odkazujú alebo odkazujú na webovú stránku.
		</p>
		<p>
			V každom prípade musí byť každý odkaz, ktorý je určený pre webovú stránku, smerovaný
			priamo na domovskú stránku alebo domovskú stránku Webovej lokality kliknutím na URL
			webovej stránky pokrývajúcej celú obrazovku domovskej stránky alebo úvodnej stránky
			webovú stránku, takže odkaz je absolútny a úplný bez použitia
			rámy, rámce alebo hypertextové odkazy. {siteName} v žiadnom prípade neodpovedá
			a za žiadnych okolností na obsah, informácie alebo údaje súvisiace s
			webovú stránku, jej obsah alebo akúkoľvek inú záležitosť obsiahnutú na webových stránkach, platformách,
			fóra, chaty, blogy alebo sociálne siete tretích strán, ktoré odkazujú alebo odkazujú na
			Webová stránka.
		</p>
		<p>
			Je výslovne zakázané odkazovať alebo odkazovať na webovú stránku z webových stránok,
			platformy, fóra, chaty, blogy či sociálne siete v rozpore so zákonom, morálkou
			a dobré zvyky, najmä tie s pornografickými, nezákonnými, nezákonnými príp
			obsah porušujúci ľudské práva.
		</p>
		<p>
			Na druhej strane webová lokalita môže obsahovať odkazy na webové stránky tretích strán,
			platformy, fóra, chaty, blogy alebo sociálne siete. {siteName} nie
			mať ľudské a/alebo technické prostriedky na to, aby poznali alebo kontrolovali informácie a
			obsah, ktorý sa objavuje na webových stránkach tretích strán. Preto v žiadnom prípade {siteName}
			 zodpovedá za obsah prepojených stránok a pod č
			okolnosti môžu byť uvedené odkazy považované za efektívnu znalosť obsahu
			stránok, na ktoré odkazujú.
		</p>
		<h3>16. OCHRANA ÚDAJOV</h3>
		<p>
			Ako je uvedené vo svojom {privacyPolicyLink}, {siteName} sa zaväzuje používať používateľa
			údaje, rešpektovať ich dôvernosť a používať ich v súlade s
			účelu liečby, ako aj dodržať svoju povinnosť zachrániť ho.
			a prispôsobiť všetky opatrenia tak, aby nedošlo k ich zmene, strate, zaobchádzaniu alebo neoprávnenému zaobchádzaniu
			prístup v súlade s ustanoveniami súčasnej legislatívy týkajúcej sa
			ochranu osobných údajov.
		</p>
		<p>
			Webová stránka zahŕňa vhodné záruky a používa priemyselný štandard
			technológie na zlepšenie bezpečnosti, integrity, úplnosti, presnosti a
			ochranu osobných údajov, ktoré zhromaždil a zriadil
			primerané opatrenia na ochranu týchto informácií pred možnou stratou alebo
			zneužitia. Jej pravidlá o ochrane a bezpečnosti údajov sa pravidelne revidujú
			a vylepšené, keď je to potrebné, a snaží sa zabezpečiť, aby to bolo len povolené
			osoby majú prístup k informáciám poskytnutým Používateľom.
		</p>
		<p>
			Ak sa chcete dozvedieť viac o riadení a liečbe, ktorú vykonáva {siteName}
			 vašich údajov si prečítajte naše {privacyPolicyLink} a naše {cookiesPolicyLink}.
		</p>
		<h3>17. TRVANIE A MODIFIKÁCIA</h3>
		<p>
			Tieto podmienky používania budú v platnosti tak dlho, ako budú vystavené
			užívateľov, a to tak, že akonáhle budú úplne alebo čiastočne upravené alebo aktualizované,
			tieto podmienky prestanú platiť ako nové podmienky používania
			tie, ktoré pokračujú v regulácii používania webovej stránky.
		</p>
		<p>
			{siteName} si vyhradzuje právo ich skontrolovať, upraviť alebo aktualizovať
			podmienky používania kedykoľvek. V prípade akejkoľvek zmeny týchto podmienok
			o použití z akéhokoľvek dôvodu, {siteName} upozorní používateľov na domovskej stránke
			web o uvedenej okolnosti, aby boli riadne informovaní a mohli sa poradiť
			revízie, úpravy alebo aktualizácie súčasných podmienok používania
			vaša spokojnosť.
		</p>
		<h3>18. VŠEOBECNÉ</h3>
		<p>
			V žiadnom prípade a za žiadnych okolností nemôže nedostatok výkonu vašich práv
			by {siteName} chápané ako ich vzdanie sa.
		</p>
		<p>
			Nadpisy uvedené v týchto podmienkach sú len orientačné resp
			informatívne, aby neovplyvňovali, nespresňovali a nerozširovali výklad
			z toho.
		</p>
		<p>
			V prípade, že niektorý z bodov obsiahnutých v týchto podmienkach bol
			vyhlásené za neplatné, zneužívajúce alebo nevykonateľné, úplne alebo čiastočne, súdom
			alebo správneho orgánu, uvedené vyhlásenie bude individuálne ovplyvňovať doložku
			predmetného, berúc ho ako nie a bez vyhlásenia neplatnosti, zneužitia resp
			nepoužiteľnosť sa za akýchkoľvek okolností rozšíri na zvyšok
			podmienky, ktoré budú pretrvávať.
		</p>
		<p>
			Tieto podmienky používania, ako aj {privacyPolicyLink} a {cookiesPolicyLink}
			sa vždy riadia aktuálnymi španielskymi predpismi.
		</p>
		<h3>19. SLUŽBY ZÁKAZNÍKOM</h3>
		<p>
			V prípade akéhokoľvek objasnenia, incidentu alebo nároku nás môžete kontaktovať prostredníctvom:<br />
			E-mail: {supportLink}<br />
			Poštová adresa: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španielsko.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Posledná aktualizácia: 10. júna 2024',
		content: `
			<h3>1. Zodpovedná strana a popis</h3>
			<h5>1.1. Zodpovedný</h5>
			<p>Osobou zodpovednou za zaobchádzanie s touto stránkou je Remove Background S.L (ďalej len Remove Background 
			alebo Služba), s adresou Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španielsko.</p>
			<p>NIF: B56768260<br> E-mail: {supportLink}</p>

			<h5>1.2. Popis</h5>
			<p>Prijatie zásad ochrany osobných údajov Odstrániť pozadie (ďalej len „Zásady ochrany osobných údajov“) je nevyhnutnou podmienkou 
				na používanie našej webovej stránky a poskytovanie služby (ďalej len „Služba“).<br>
				Tieto zásady ochrany osobných údajov upravujú zhromažďovanie, spracovanie a používanie vašich osobných a neosobných údajov 
				ako používateľ Odstrániť pozadie od dátumu účinnosti, ktorý sa zobrazuje v hlavičke.<br>
				Na spracovanie vašich osobných údajov je funkcia Remove Background v súlade s aktuálnou miestnou a európskou legislatívou, 
				ako aj jeho vykonávacie predpisy.</p>


			<h3>2. Zhromaždené informácie</h3>
			<p>Prístup na našu webovú stránku je možný bez toho, aby ste museli poskytovať akékoľvek informácie, hoci sa musíte zaregistrovať a / 
				alebo uzavrieť zmluvu o našich plánoch, budete nám musieť poskytnúť nejaké osobné údaje. Informácie (osobné 
				alebo neosobné) zhromaždené Službou sa môžu v závislosti od toho líšiť.<br>
				Osobné a neosobné informácie zhromaždené Službou sa k nám dostanú tromi spôsobmi: 1) tým, ktorý 
				sa zhromažďuje automaticky 2) to, čo nám poskytnete dobrovoľne a 3) to, čo poskytnú tretie strany.</p>

			<h5>2.1. Ten, ktorý sa zbiera automaticky</h5>
			<p>Tieto informácie budú pozostávať z:</p>
			<ul>
				<li>Tá, ktorá sa zbiera prostredníctvom súborov cookie alebo podobných mechanizmov uložených vo vašom zariadení, vždy s vaším súhlasom alebo v 
					v súlade s inými právnymi základmi. Viac informácií nájdete v našich Zásadách používania súborov cookie.</li>
				<li>Adresa IP, z ktorej je vytvorené pripojenie, typ použitého zariadenia a jeho charakteristiky, verzia 
					operačný systém, typ prehliadača, jazyk, dátum, krajina, čas požiadavky, 
					okrem iného adresu URL z adresy, z ktorej prichádzate, adresu URL, na ktorú idete, alebo použitú mobilnú sieť.</li>
				<li>Údaje o používaní služby a možné chyby zistené počas jej používania.</li>
				<li>Okrem toho, Odstrániť pozadie používa Google Analytics, analytickú službu poskytovanú spoločnosťou Google, LLC. 
					so sídlom v Spojených štátoch amerických so sídlom na adrese 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					Na poskytovanie týchto služieb používajú cookies, ktoré zhromažďujú informácie vrátane IP adresy užívateľa, 
					ktoré bude prenášať, spracovávať a uchovávať Google za podmienok stanovených na webe www.google.com. 
					Vrátane možného prenosu uvedených informácií tretím stranám z dôvodov zákonnej požiadavky resp 
					keď uvedené tretie strany spracúvajú informácie v mene spoločnosti Google.</li>
			</ul>
			<p>V každom prípade môžete zakázať súbory cookie služby Google Analytics <a href="{externalLink: disableGoogleAnalyticsLink}">tu</a>.</p>

			<h5>2.2. Ten, ktorý dobrovoľne poskytnete</h5>
			<p>Tieto informácie budú pozostávať z:</p>
			<ul>
				<li>Všetky údaje sú povinné.</li>
				<li>Ten, ktorý vyžaduje Odstrániť pozadie na dokončenie vašej registrácie na webe: okrem iného meno a priezvisko, adresa a e-mail.</li>
				<li>Všetky údaje sú povinné.</li>
				<li>Informácie, či už osobné alebo nie, na dokončenie zmluvy o poskytovaní služby, ako je vaša e-mailová adresa a číslo vašej kreditnej alebo debetnej karty.</li>
				<li>Informácie, či už osobné alebo nie, ktoré môžu obsahovať správy odoslané prostredníctvom kontaktných alebo názorových kanálov vytvorených v rámci Služby, 
					napríklad vaše meno a e-mail.</li>
			</ul>

			<h5>2.3. Ten, ktorý poskytujú tretie strany</h5>
			<p>Tieto informácie budú pozostávať z:</p>
			<ul>
				<li>Tú, ktorú poskytujú platobné systémy alebo spracovatelia kreditných kariet, ako je čas nákupu alebo jeho suma.</li>
			</ul>


			<h3>3. Práva a účely</h3>
			<p>Informujeme vás, že vyplnenie formulárov je dobrovoľné. Ak však nevyplníte povinné polia 
				(zvyčajne označené hviezdičkou), používanie niektorých funkcií Služby nebude možné alebo bude obmedzené.<br>
				Osobné údaje, ktoré nám poskytnete, budú začlenené a spracované v Registri liečebných činností odstránenia pozadia 
				aby sme mohli vybaviť vaše požiadavky, poskytnúť požadovanú službu a informovať vás o záležitostiach súvisiacich s činnosťou 
				spoločnosti a jej služieb.<br>
				Kedykoľvek môžete uplatniť práva na prístup, opravu, vymazanie, obmedzenie vašej liečby, 
				námietku a prenosnosť vašich osobných údajov e-mailom na adresu: {supportLink} alebo na poštovú adresu: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španielsko.<br>
				V oboch prípadoch sa musíte identifikovať svojím menom a priezviskom a v prípade potreby aj kópiou svojho DNI alebo občianskeho preukazu.<br>
				V prípade, že ste súhlas udelili na konkrétny účel, máte právo súhlas kedykoľvek odvolať, 
				bez toho, aby bola dotknutá zákonnosť zaobchádzania založeného na súhlase pred jeho odvolaním.<br>
				Okrem toho, ak sa domnievate, že existuje problém so spôsobom, akým Odstrániť pozadie narába s vašimi údajmi, 
				svoje sťažnosti môžete nasmerovať na príslušný <a href="{knowYourRightsLink}">úrad na ochranu údajov</a>, ktorým je <a href="{aepdLink}">Španielska agentúra pre ochranu údajov</a> 
				ten, ktorý je uvedený v prípade Španielska.</p>


			<h3>4. Vek</h3>
			<p>Pokiaľ ide o používanie služby online, vyhlasujete, že ste plnoletý a máte potrebné zákonné 
				schopnosť byť viazaný touto zmluvou a používať stránku v súlade s jej podmienkami, ktoré v plnom rozsahu beriete 
				pochopiť a uznať.<br>
				Vyhlasujete, že všetky informácie, ktoré poskytnete na prístup k Službe, pred a počas jej používania, sú pravdivé, úplné 
				a presné.</p>


			<h3>5. Použitie údajov</h3>
			<p>Odstrániť pozadie použije zhromaždené údaje na:</p>
			<ul>
				<li>Spravujte a aktualizujte Službu (právnym základom je náš oprávnený záujem na udržiavaní a udržiavaní Služby 
					aktuálne a v dobrom stave).</li>
				<li>Odpovedzte na otázky, ktoré vznesiete (právnym základom je náš legitímny záujem na vybavovaní žiadostí a 
					pochybnosti našich používateľov).</li>
				<li>Spracujte platby, ktoré uskutočníte (právnym základom je zmluva).</li>
				<li>Poskytovať zmluvnú službu (právnym základom je zmluva).</li>
				<li>Udržiavajte bezpečnosť Služby, vyšetrujte nezákonné aktivity, presadzujte naše zmluvné podmienky a
					pomáhať bezpečnostným zložkám štátu v rámci ich prípadných vyšetrovaní (právnym základom je náš 
					oprávnený záujem na zaručení a zachovaní bezpečnosti Služby a jej používateľov).</li>
			</ul>
			<p>Odstránenie pozadia nepoužíva automatické rozhodnutia, hoci môže generovať základné používateľské profily, 
				právnym základom je náš oprávnený záujem na komerčné účely a poskytovanie personalizovaných ponúk.<br>
				Odstrániť pozadie môže tiež použiť informácie o používateľovi vo forme súhrnných a anonymných údajov na ich zobrazenie tretím stranám. 
				Môžete tiež zdieľať štatistiky a demografické informácie o používateľoch a ich používaní Služby s tretími stranami. 
				Nič z toho však neumožní týmto tretím stranám, aby vás osobne identifikovali.</p>

			<h5>5.1. V e-mailoch a kontaktných formulároch</h5>
			<p>Webové stránky majú šifrovanie SSL, ktoré umožňuje používateľovi bezpečne odosielať svoje osobné údaje prostredníctvom štandardných kontaktných formulárov.<br>
				Zhromaždené osobné údaje budú predmetom automatizovaného spracovania a začlenené do príslušných súborov 
				záznam o spracovateľských činnostiach a ktorého vlastníkom je Remove Background.</p>
			<p>V tomto zmysle:</p>
			<ul>
				<li>Dostaneme vašu IP adresu, ktorá sa použije na overenie pôvodu správy, aby sme vám mohli poskytnúť primeranú ponuku 
					odporúčania (napríklad prezentovať informácie v správnom jazyku) a odhaliť prípadné nezrovnalosti 
					(napríklad možné pokusy o kybernetický útok na Službu), ako aj údaje súvisiace s vaším ISP.</li>
				<li>Podobne nám môžete poskytnúť svoje údaje telefonicky, e-mailom a inými uvedenými komunikačnými prostriedkami.</li>
			</ul>
			<p>Pokiaľ ide o použitý spôsob platby:</p>
			<ul>
				<li>Našimi poskytovateľmi platobných služieb, ktorí platia za poskytovanie našich služieb, sú kreditné alebo debetné karty. 
					Služba ani jej zamestnanci nebudú mať nikdy prístup k bankovým údajom (napríklad k číslu kreditnej karty) 
					ktoré používateľ ako zákazník poskytne týmto tretím stranám.</li>
			</ul>


			<h3>6. Uchovávanie údajov</h3>
			<p>Nižšie je uvedené, ako dlho sa údaje spracúvané Službou uchovávajú:</p>
			<ul>
				<li>Rozčlenené údaje budú uchovávané bez obdobia na odstránenie.</li>
				<li>
					Údaje o zákazníkoch budú uchovávané na nevyhnutné minimum a môžu byť uchovávané do:
					<ul>
						<li>5 rokov, podľa čl. 1964 Občianskeho zákonníka (osobné úkony bez osobitnej lehoty).</li>
						<li>6 rokov, podľa čl. 30 Obchodného zákonníka (napríklad účtovné knihy alebo faktúry).</li>
					</ul>
				</li>
				<li>Údaje používateľov budú uchovávané maximálne 12 mesiacov, aby bolo možné vybaviť ich žiadosti.</li>
			</ul>


			<h3>7. Údaje zdieľané s tretími stranami</h3>
			<p>Časť Služby spravujú tretie strany.<br>
				Odstrániť pozadie vyžaduje, aby okrem svojich vlastných dodržiavali aj príslušné zásady ochrany osobných údajov. Odstrániť pozadie však nezodpovedá za dodržiavanie uvedených pravidiel.<br>
				Za určitých okolností môže Odstrániť pozadie zdieľať, používať alebo uchovávať s tretími stranami akékoľvek zhromaždené osobné informácie:</p>
			<ul>
				<li>Poskytovanie Služby:</li>
			</ul>
			<p>Poskytovatelia služieb, ktorí vykonávajú funkcie v našom mene, ako sú platobné služby, webhosting, obchodné analýzy, služby zákazníkom alebo webový marketing. Títo poskytovatelia služieb môžu zhromažďovať informácie, ktoré sú potrebné na vykonávanie ich funkcií, a mať k nim prístup, ale nesmú tieto informácie zdieľať ani používať na žiadny iný účel.</p>
			<ul>
				<li>Spolupráca s príslušnými orgánmi:</li>
			</ul>
			<p>Ak sa domnievame, že je to primerane potrebné na splnenie akéhokoľvek zákona, právneho procesu alebo oprávneného záujmu. V každom prípade poskytneme iba tie informácie, ktoré sú nevyhnutne potrebné.</p>


			<h3>8. Bezpečnostné opatrenia</h3>
			<p>Odstránenie pozadia prijíma všetky potrebné technické a organizačné opatrenia
				chrániť bezpečnosť a integritu zhromaždených osobných a neosobných informácií. 
				Pred neoprávneným prístupom a jeho náhodnou zmenou, stratou alebo zničením.<br>
				V žiadnom prípade nemôže Odstrániť pozadie zaručiť absolútnu bezpečnosť zhromaždených informácií, 
				takže musíte vždy spolupracovať a používať zdravý rozum pri zdieľaných informáciách.<br>
				Beriete na vedomie a beriete na vedomie, že aj po vymazaní môžu byť osobné a neosobné informácie 
				zostane viditeľný vo vyrovnávacej pamäti alebo ak ho iní používatelia skopírovali alebo uložili.</p>


			<h3>9. Zmeny Zásad ochrany osobných údajov</h3>
			<p>Tieto Zásady ochrany osobných údajov môžeme v budúcnosti aktualizovať. O jeho zmenách vás budeme informovať odoslaním oznámenia na uvedenú e-mailovú adresu a/alebo umiestnením oznámenia na viditeľnom mieste na našej webovej lokalite.</p>


			<h3>10. Kontakt</h3>
			<p>Ak máte otázky týkajúce sa týchto Zásad ochrany osobných údajov, kontaktujte nás na adrese:</p>
			<p>E-mail: {supportLink}<br> 
				Adresa: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španielsko.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Posledná aktualizácia: 10. júna 2024',
		content: `
			<h3>1. Kto je zodpovedný a ako ho kontaktovať?</h3>
			<p>Správcom tejto stránky je Remove Background S.L s adresou Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španielsko.</p>
			<p>Môžete ho kontaktovať prostredníctvom e-mailu na adrese {supportLink}.</p>

			<h3>2. Aké údaje sa zhromažďujú?</h3>
			<p>
				Údaje automaticky zhromažďujeme prostredníctvom súborov cookie, ktoré načítame do vášho zariadenia, vrátane analýzy. 
				Zhromažďujeme tiež IP, z ktorej sa pripojenie uskutočňuje, typ použitého zariadenia a jeho vlastnosti, 
				verzia operačného systému, typ prehliadača, jazyk, dátum, krajina, čas požiadavky, 
				okrem iného adresu URL, z ktorej prichádzate, adresu URL, na ktorú idete, alebo použitú mobilnú sieť.<br>
				Používateľ nám dobrovoľne poskytne niektoré informácie, ako je jeho meno a priezvisko, e-mail alebo bankové údaje 
				aby ste nás mohli kontaktovať, prihlásiť sa do služby alebo si zakúpiť predplatné.
			</p>

			<h3>3. Na čo sa zhromaždené údaje používajú?</h3>
			<p>
				Služba použije zhromaždené údaje okrem iného na správu a aktualizáciu služby, odpovedá na vaše požiadavky, 
				posielať vám náš newsletter a propagačné ponuky e-mailom, spravovať vašu registráciu na platforme, spravovať a poskytovať 
				služby súvisiace s vaším predplatným, spracovávať vami uskutočnené platby a vystavovať príslušné faktúry, 
				udržiavať bezpečnosť Služby, vyšetrovať nezákonné aktivity, presadzovať naše zmluvné podmienky a 
				pomáhať bezpečnostným zložkám a orgánom štátu v rámci ich prípadných vyšetrovaní.
			</p>

			<h3>4. Ako dlho sa uchovávajú?</h3>
			<ul>
				<li>Rozčlenené údaje budú uchovávané bez obdobia na odstránenie.</li>
				<li>
					Údaje o zákazníkoch budú uchovávané na nevyhnutné minimum a môžu byť uchovávané do:
					<ul>
						<li>5 rokov, podľa čl. 1964 Občianskeho zákonníka (osobné úkony bez osobitnej lehoty).</li>
						<li>6 rokov, podľa čl. 30 Obchodného zákonníka (napr. účtovné knihy alebo faktúra).</li>
					</ul>
				</li>
				<li>Údaje používateľov budú uchovávané maximálne 12 mesiacov, aby bolo možné vyhovieť ich požiadavkám.</li>
				<li>Údaje používateľa nahrané Službou na stránky a profily na sociálnych sieťach budú uchovávané od momentu, keď používateľ poskytne svoj súhlas, až kým ho neodvolá.</li>
			</ul>

			<h3>5. Aké sú vaše práva ako používateľa?</h3>

			<p>
				Právo na prístup: Dotknutá strana má právo získať od prevádzkovateľa potvrdenie o tom, či 
				alebo sa nespracúvajú osobné údaje, ktoré sa jej týkajú.
			</p>
			<p>
				Právo na opravu: dotknutá strana má právo získať bez zbytočného odkladu od prevádzkovateľa údajov 
				opravu osobných údajov, ktoré sú nepresné a ktoré sa ho priamo dotýkajú. Rovnako aj záujemca 
				má právo na doplnenie neúplných osobných údajov, a to aj prostredníctvom dodatočného vyhlásenia.
			</p>
			<p>
				Právo na vymazanie: Dotknutá strana má právo bez zbytočného odkladu dosiahnuť od správcu údajov vymazanie 
				osobných údajov, ktoré sa ho týkajú.
			</p>
			<p>
				Právo na obmedzenie spracovania údajov: spočíva v získaní obmedzenia spracovania vašich údajov zodpovednou osobou, 
				hoci jeho výkon má dva aspekty: 1) Keď napadnete presnosť svojich osobných údajov, počas obdobia, ktoré to umožňuje 
				zodpovedná osoba na overenie a 2) keď ste namietali proti spracúvaniu vašich osobných údajov, že zodpovedná osoba 
				vykonáva na základe oprávneného záujmu alebo poslania verejného záujmu, pričom poverená osoba overí, či tieto dôvody 
				zvíťaziť nad tvojím.
			</p>
			<p>
				Právo na prenosnosť údajov: Dotknutá strana má právo získať osobné údaje, ktoré sa jej týkajú, 
				ktoré poskytol prevádzkovateľovi údajov v štruktúrovanom formáte na bežné používanie a mechanické čítanie, a 
				odovzdať ich inému prevádzkovateľovi bez toho, aby tomu prevádzkovateľ, ktorému boli poskytnuté, bránil.
			</p>
			<p>
				V tomto zmysle bude mať zainteresovaná strana právo na prenos osobných údajov priamo od prevádzkovateľa 
				kontrolovať, ak je to technicky možné.
			</p>

			<h3>6. Ako môžete uplatniť svoje práva?</h3>

			<p>
				Svoje práva na osobné údaje môžete uplatniť kedykoľvek odoslaním e-mailu na: {supportLink} alebo poštovú adresu: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španielsko. V oboch prípadoch sa musíte identifikovať svojím menom a priezviskom, 
				a v prípade potreby aj kópiu vášho DNI alebo občianskeho preukazu.<br>
				Okrem toho, ak sa domnievate, že existuje problém so spôsobom, akým Odstrániť pozadie narába s vašimi údajmi, môžete svoje nároky nasmerovať 
				na príslušný <a href="{knowYourRightsLink}">úrad na ochranu údajov</a>, ktorým je <a href="{aepdLink}">Španielska agentúra na ochranu údajov</a> 
				ten, ktorý je uvedený v prípade Španielska.
			</p>

			<h3>7. Sú prijaté bezpečnostné opatrenia?</h3>
			<p>
				Služba prijíma všetky potrebné technické a organizačné opatrenia na ochranu bezpečnosti a integrity osôb 
				a zhromaždené neosobné informácie. Pred neoprávneným prístupom a náhodnou zmenou, stratou alebo zničením.<br>
				Služba v žiadnom prípade nemôže zaručiť absolútnu bezpečnosť zhromaždených informácií, takže musíte spolupracovať a 
				v súvislosti so zdieľanými informáciami vždy používajte zdravý rozum.<br>
				Beriete na vedomie a beriete na vedomie, že aj po odstránení môžu osobné a neosobné informácie zostať viditeľné vo vyrovnávacej pamäti alebo 
				ak sú skopírované alebo uložené inými používateľmi.
			</p>

			<h3>8. Existujú prenosy osobných údajov alebo medzinárodné prenosy?</h3>

			<p>
				Neprenášame údaje ani medzinárodné prevody. Existujú však tretie strany, ktoré spravujú časť Služby 
				že od nás vyžaduje dodržiavanie našich zásad ochrany osobných údajov, pokiaľ sa na ne vzťahujú a že majú svoje vlastné. 
				Tieto tretie strany sú poskytovatelia služieb, ktorí vykonávajú funkcie v našom mene, ako napríklad webhosting, 
				analytické monitorovanie alebo vývoj webu.<br>
				Taktiež, ak sa domnievame, že je to primerane potrebné na uspokojenie akéhokoľvek zákona, právneho procesu alebo oprávneného záujmu. 
				V každom prípade poskytneme len nevyhnutne potrebné informácie.
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: 'Posledná aktualizácia: 21. júna 2024',
		content: `
			<h3>Súhrn</h3>
			<ul>
			    <li>Používané súbory cookie: <strong>Vlastné a tretej strany</strong></li>
			    <li>Používajú sa na získanie štatistík? <strong>Áno, na základe nášho oprávneného záujmu o lepšie spravovanie služby.</strong></li>
			    <li>Služby tretích strán, ktoré inštalujú súbory cookie prostredníctvom tejto webovej lokality: <strong>Google, Google Analytics, Cloudflare a Stripe.</strong></li>
			</ul>

			<h3>Ako nakonfigurovať a zakázať súbory cookie</h3>
			<p>
			    Súbory cookie nainštalované vo vašom zariadení môžete povoliť, blokovať alebo vymazať z webového prehliadača. Ak nepovolíte inštaláciu súborov cookie na vašom zariadení, 
			    zážitok z prehliadania sa môže zhoršiť. Nižšie nájdete, ako nakonfigurovať súbory cookie v každom prehliadači:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Typy a použitie</h3>
			<p>Služba používa vlastné súbory cookie a súbory cookie tretích strán na zlepšenie prehliadania, poskytovanie služieb a získavanie štatistík o používaní webovej lokality.</p>

			<h3>2. Čo je súbor cookie a na čo sa používa?</h3>
			<p>
			    Súbor cookie je textový súbor, ktorý sa odošle do webového prehliadača vášho počítača, mobilu alebo tabletu a používa sa na ukladanie a získavanie informácií o
			    prehliadanie dokončené. Napríklad, aby ste si zapamätali svoje používateľské meno a heslo alebo preferencie vášho profilu.
			</p>

			<h3>3. Aké typy súborov cookie existujú?</h3>
			<p>Podľa toho, kto ich spravuje:</p>
			<ul>
			    <li>vlastniť súbory cookie; sú odosielané do vášho prehliadača z nášho vlastného zariadenia alebo webových domén.</li>
			    <li>súbory cookie tretích strán; sú odosielané do vášho prehliadača zo zariadení alebo webových domén, ktoré nespravujeme priamo my, ale tretí subjekt, ako je Google.</li>
			</ul>
			<p>Na základe toho, ako dlho zostávajú aktívne, existujú:</p>
			<ul>
			    <li>Súbory cookie relácie; zostávajú v súbore cookie vášho prehliadača, kým neopustíte webovú stránku, takže žiadne nezostanú vo vašom zariadení.</li>
			    <li>Trvalé súbory cookie; zostávajú vo vašom zariadení a naša webová stránka ich číta pri každej vašej novej návšteve. Tieto súbory cookie prestanú fungovať po určitom dátume.</li>
			</ul>
			<p>Nakoniec, podľa ich účelu, máme:</p>
			<ul>
			    <li>technické súbory cookie; zlepšujú prehliadanie a správne fungovanie webovej stránky.</li>
			    <li>Súbory cookie prispôsobenia; umožňujú prístup k službe s preddefinovanými charakteristikami založenými na sérii kritérií.</li>
			    <li>súbory cookie služby Analytics; umožňujú merať a štatisticky analyzovať využívanie poskytovanej služby.</li>
			</ul>
			<p>Zoznam súborov cookie tretích strán, ktoré používa <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Ich súbory cookie (NID alebo SÚHLAS) umožňujú prispôsobiť spôsob zobrazovania reklám mimo spoločnosti Google alebo ukladať informácie
			        ako je preferovaný jazyk pri zobrazovaní výsledkov vyhľadávania.<br><a href="{externalLink: googleCookieTypes}">Viac informácií</a> o typoch súborov cookie, ktoré spoločnosť Google používa vo svojich rôznych službách.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: Ich súbory cookie (napríklad _ga) umožňujú počítať, koľkokrát používateľ navštívi webovú stránku, ako, kedy a odkiaľ.<br>
			        V každom prípade môžete zakázať súbory cookie služby Google Analytics <a href="{externalLink: disableGoogleAnalytics}">tu</a>.
			    </li>
			    <li>Cloudflare: Ak sa chcete dozvedieť o pravidlách a používaní súborov cookie Cloudflare, kliknite na <a href="{externalLink: cloudflareCookiesPolicy}">tento odkaz</a>.</li>
			    <li>Stripe: Nájdite informácie <a href="{externalLink: stripeCookiesPolicy}">tu</a> o pravidlách a používaní súborov cookie Stripe.</li>
			</ul>
			
		`
	}
};
